import { Accordion, AccordionDetails, AccordionSummary, Box, Button, MenuItem, SwipeableDrawer, TextField, Typography } from "@mui/material";
import React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ColorPicker from "../../Controls/colorPicker";
import { Slider } from "@mui/material/node";
import ButtonExportProject from "./buttonExportProject";
import ButtonDeleteProject from "./buttonDeleteProject";
import ProjectVisibilityManagement from "./projectVisibilityManagement";
import SelectDefaultNodeShape from "./selectDefaultNodeShape";
import SelectDefaultEdgeShape from "./selectDefaultEdgeShape";
import SelectDefaultEdgeType from "./selectDefaultEdgeType";

export default function ProjectDrawer(props) {
  const [state, setState] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [projectData, setProjectData] = React.useState({
    name: props.project?.name,
    description: props.project?.description,
    createdon: props.project?.createdon,
    ispublic: props.project?.ispublic,
    allowcomments: props.project?.allowcomments,
    defaultshapetype: props.project?.defaultshapetype,
    defaultedgetype: props.project?.defaultedgetype,
    defaultconnectiontype: props.project?.defaultconnectiontype,
    themecolorelement: props.project?.themecolorelement,
    themecolorelementtext: props.project?.themecolorelementtext,
    themecolorline: props.project?.themecolorline,
  });

  const handleProjectDataChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setProjectData((prev) => {
      return { ...prev, [name]: value }
    });
    console.log(projectData);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSaveButtonClick = (e) => {
    props.update(projectData);
    setState(false); 
    props.setState(false);
  };

  const handleCancelButtonClick = (e) => {
    setProjectData({
      name: props.project?.name,
      description: props.project?.description,
      createdon: props.project?.createdon,
      ispublic: props.project?.ispublic,
      allowcomments: props.project?.allowcomments,
      defaultshapetype: props.project?.defaultshapetype,
      defaultedgetype: props.project?.defaultedgetype,
      defaultconnectiontype: props.project?.defaultconnectiontype,
      themecolorelement: props.project?.themecolorelement,
      themecolorelementtext: props.project?.themecolorelementtext,
      themecolorline: props.project?.themecolorline,
    });
    setState(false); 
    props.setState(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState(open);
    props.setState(open);
  };

  return (
    <div>
      <SwipeableDrawer
        anchor="left"
        open={props.state}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <Box
          sx={{ width: 350 }}
          role="presentation"
        // onClick={toggleDrawer(false)}
        // onKeyDown={toggleDrawer(false)}
        >
          <Box align='right'>
            <Button size="small" color="error" sx={{ m: 1 }} onClick={handleCancelButtonClick}>Cancel</Button>
            <Button size="small" color="success" sx={{ m: 1 }} onClick={handleSaveButtonClick}>Save</Button>
          </Box>
          <div>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography sx={{ flexShrink: 0 }}>
                  General settings
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  id="name"
                  name="name"
                  label="Project Name"
                  size="small"
                  margin="dense"
                  fullWidth
                  value={projectData.name}
                  onChange={handleProjectDataChange} />
                <TextField
                  id="description"
                  name="description"
                  label="Project Description"
                  size="small"
                  margin="dense"
                  fullWidth
                  multiline
                  rows={6}
                  value={projectData.description}
                  onChange={handleProjectDataChange} />
              </AccordionDetails>
            </Accordion>
            
            {/*<Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <Typography sx={{ flexShrink: 0 }}>Template & Style</Typography>
              </AccordionSummary>
               <AccordionDetails>
                <SelectDefaultNodeShape handleChange={handleProjectDataChange} value={projectData.defaultshapetype}/>
                <SelectDefaultEdgeShape handleChange={handleProjectDataChange} value={projectData.defaultedgetype}/>
                <SelectDefaultEdgeType handleChange={handleProjectDataChange} value={projectData.defaultconnectiontype}/>                
                <Typography variant="caption">
                  Shape size
                </Typography>
                <Slider defaultValue={50} aria-label="Default" valueLabelDisplay="auto" /> */}
                {/* <TextField id="template-color" select label="Color template" size="small" margin="dense" sx={{ width: "100%" }}>
                   {styleShape.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))} 
                </TextField>  */}
                {/* <Typography variant="caption">
                  Color schema details
                </Typography>
                <ColorPicker label="Element" name="themecolorelement" handleChange={handleProjectDataChange} color={projectData.themecolorelement}></ColorPicker>
                <ColorPicker label="Element Text" name="themecolorelementtext" handleChange={handleProjectDataChange} color={projectData.themecolorelementtext}></ColorPicker>
                <ColorPicker label="Line" name="themecolorline" handleChange={handleProjectDataChange} color={projectData.themecolorline}></ColorPicker>
              </AccordionDetails>
            </Accordion> */}
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3bh-content"
                id="panel3bh-header"
              >
                <Typography sx={{ flexShrink: 0 }}>
                  Visibility
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ProjectVisibilityManagement projectData={projectData} handleChange={handleProjectDataChange}/>
              </AccordionDetails>
            </Accordion>
            {/* <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4bh-content"
                id="panel4bh-header"
              >
                <Typography sx={{ flexShrink: 0 }}>Personal data</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit
                  amet egestas eros, vitae egestas augue. Duis vel est augue.
                </Typography>
              </AccordionDetails>
            </Accordion> */}
            <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5bh-content"
                id="panel5bh-header"
              >
                <Typography sx={{ flexShrink: 0 }}>Project</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ButtonExportProject canvasRef={props.canvasRef}/>
                <ButtonDeleteProject/>
              </AccordionDetails>
            </Accordion>
          </div>
        </Box>
      </SwipeableDrawer>
    </div>
  );
}